module.exports = __webpack_public_path__ + "static/assets/1bd7e4561286956370f8bcc27c43aa82.png";